import Litepicker from 'litepicker';
import $ from 'jquery';
import * as d3 from './d3';
import './nv.d3';

const funds = {
    settings: {
        elements: {
            chartOverlay: null,
            chartTabButtons: null,
            chartDateButtons: null,
            checkboxes: null,
            tableCategorySelect: null,
            tableProductSelect: null,
            tableDots: null,
        },
        tableSelectProduct: 'Wszystkie',
        tableSelectCategory: 'Wszystkie',
        filterChart: {
            tab: null,
            date: null
        },
        calendarContainer: null,
        chartData: [],
        chartElement: null,
        calendar: {
            initialDate: null,
            endingDate: null,
        },
        lock: false,
        queue: [],
        month: {
            'styczeń': '01',
            'luty': '02',
            'marzec': '03',
            'kwiecień': '04',
            'maj': '05',
            'czerwiec': '06',
            'lipiec': '07',
            'sierpień': '08',
            'wrzesień': '09',
            'październik': '10',
            'listopad': '11',
            'grudzień': '12'
        },
        monthArray: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'],
        currentDate: {
            year: null,
            month: null
        }
    },
    chart: null,
    getElements() {
        this.settings.calendarContainer = document.querySelector('.calendar');
        this.settings.elements.chartOverlay = document.querySelector('.funds__chart__overlay');
        this.settings.elements.chartTabButtons = [...document.querySelectorAll('.funds__tabs__tab')];
        this.settings.elements.chartDateButtons = document.querySelectorAll('.funds__dates__date');
        this.settings.elements.checkboxes = [...document.querySelectorAll('.funds__table input[type="checkbox"]')];
        this.settings.elements.tableCategorySelect = [...document.querySelector('.funds__filters__category .select-options').children];
        this.settings.elements.tableProductSelect = [...document.querySelector('.funds__filters__products .select-options').children];
    },
    init() {
        const checkPage = document.querySelector('.funds__chart');
        if (checkPage == null) {
            return;
        }

        this.settings.currentDate.year = new Date().getFullYear();
        this.settings.currentDate.month = this.settings.monthArray[new Date().getMonth()];

        //this.initializeChart();
        this.getElements();
        this.checkChartFilters();

        this.chartDateButtonsClickEvent();
        this.chartTabButtonsClickEvent();
        this.tableInputsClickEvent();
        this.tableCategorySelectClickEvent();
        this.tableProductSelectClickEvent();

        this.switchContainer();
        this.setCalendar();
        this.showAdditionalSettings();

    },
    showAdditionalSettings() {
        let $this = this;
        $('.funds__table__values__dots').click(
            function (e) {
                e.stopPropagation();
                $(this).toggleClass('active')
                $('.funds__table__values__dots').not(this).removeClass('active')
            }
        )
        $(document).click(
            function () {
                $('.funds__table__values__dots').removeClass('active')
            }
        )
        $('.funds__table__values__dots__list__item--csv a').click(
            function () {
                $this.downloadCSV(this)
            }
        )
    },
    initializeChart() {
        if (this.chart) {
            return;
        }


        let $this = this;
        nv.addGraph(
            function () {
                document.getElementById('chart').style.visibility = "visible";
                $this.chart = nv.models.lineChart()
                    .margin({left: 100})  //Adjust chart margins to give the x-axis some breathing room.
                    .useInteractiveGuideline(true)  //We want nice looking tooltips and a guideline!
                    .transitionDuration(350)
                    .showLegend(true)       //Show the legend, allowing users to turn on/off line series.
                    .showYAxis(true)       //Show the y-axis
                    .showXAxis(true);        //Show the x-axis
                $this.chart.noData("Brak danych.");
                $this.chart.xAxis
                    .tickFormat(function(d) {
                        var date = new Date(d);
                        return d3.time.format('%d-%m-%y')(date);
                    });


                if ($this.settings.filterChart.tab === 'rate_of_return') {
                    $this.chart.yAxis.showMaxMin(true).tickFormat(function (d) {
                        return parseFloat(d).toFixed(2) + ' %'
                    })
                } else if ($this.settings.filterChart.tab === 'absolute_value') {
                    $this.chart.yAxis.showMaxMin(true).tickFormat(function (d) {
                        return parseFloat(d).toFixed(2) + ' zł'
                    })
                } else {
                    $this.chart.yAxis     //Chart y-axis settings
                        .tickFormat(function (d) {
                            return parseFloat(d).toFixed(2) + ' PLN'
                        });
                }

                $this.chart.color(
                    function (d, i) {
                        var colors = d3.scale.category10().range();
                        return colors[i % colors.length];
                    }
                )

                /* Done setting the chart up? Time to render it!*/
                $this.chartElement = d3.select('#chart svg')    //Select the <svg> element you want to render the chart in.
                    .datum($this.settings.chartData);          //Finally, render the chart!
                $this.chartElement.transition().duration(500).call($this.chart)

                //Update the chart when window resizes.
                nv.utils.windowResize(function () {
                    $this.chart.update()
                });

                return $this.chart;
            }
        );

    },
    updateChart() {
        let data = this.settings.chartData;
        document.getElementById('chart').style.visibility = "visible";

        if (this.settings.filterChart.tab === 'rate_of_return') {
            this.chart.yAxis.showMaxMin(true).tickFormat(function (d) {
                return parseFloat(d).toFixed(2) + ' %'
            })
        } else if (this.settings.filterChart.tab === 'absolute_value') {
            this.chart.yAxis.showMaxMin(true).tickFormat(function (d) {
                return parseFloat(d).toFixed(2) + ' zł'
            })
        } else {
            this.chart.yAxis     //Chart y-axis settings
                .tickFormat(function (d) {
                    return parseFloat(d).toFixed(2) + ' PLN'
                });
        }

        // Update the SVG with the new data and call chart
        this.chartElement.datum(data).transition().duration(500).call(this.chart);
        nv.utils.windowResize(this.chart.update);


    },
    destroyChart(chart) {
        document.getElementById('chart').style.visibility = "hidden";
        chart.selectAll('g').remove();
        this.chartOverlayOn();
        this.chart = null;
    },
    drawChart() {

        if (this.chart !== null) {
            this.updateChart();
        } else {
            this.initializeChart();
        }

        this.chartOverlayOff();
        if (this.settings.chartData.length === 0) {
            this.destroyChart(d3.select('#chart'))
        }
    },
    tableCategorySelectClickEvent() {
        this.settings.elements.tableCategorySelect.forEach(el => el.addEventListener('click', this.getTableSelectCategory.bind(this)))
    },
    tableProductSelectClickEvent() {
        this.settings.elements.tableProductSelect.forEach(el => el.addEventListener('click', this.getTableSelectProduct.bind(this)))
    },
    getTableSelectCategory(e) {
        this.settings.tableSelectCategory = e.target.parentElement.getAttribute('category')
        this.filterTableByCategory();
        this.filterTableByProduct();
    },
    getTableSelectProduct(e) {
        this.settings.tableSelectProduct = e.target.parentElement.getAttribute('rel')
        this.filterTableByCategory();
        this.filterTableByProduct();
    },
    filterTableByCategory() {
        const tables = document.querySelectorAll('table');

        tables.forEach(
            table => {
                const tableCategory = table.getAttribute('data-category');
                if (tableCategory != this.settings.tableSelectCategory && this.settings.tableSelectCategory != 'Wszystkie') {
                    table.style.display = "none";
                    const checkboxes = table.querySelectorAll('input[type=checkbox]');
                    checkboxes.forEach(el => el.checked = false);
                } else {
                    table.style.display = 'table';
                }
            }
        )

        this.checkChartByCategoryFilter();
    },
    filterTableByProduct() {
        const rows = document.querySelectorAll('.funds__table__values')
        const tables = document.querySelectorAll('.funds__table table')
        let $this = this;

        tables.forEach(
            table => {
                    let table_rows = $(table).find('tr[data-include-in-product]');
                    let show_table = 0;
                    $(table_rows).each(function() {

                        if($(this).attr('data-include-in-product').indexOf($this.settings.tableSelectProduct) >= 0) {
                            show_table = 1;
                        }
                    })
                    if( this.settings.tableSelectProduct != 'Wszystkie' && show_table === 0) {
                        table.style.display = "none";
                    }
            }
        )


        rows.forEach(
            row => {
                let productList = row.getAttribute('data-include-in-product');
                productList = productList.split(',');

                if (!productList.includes(this.settings.tableSelectProduct) && this.settings.tableSelectProduct != 'Wszystkie') {
                    row.style.display = "none";
                    const checkboxes = document.querySelectorAll(' table input[type=checkbox]');
                    checkboxes.forEach(el => el.checked = false);
                } else {
                    row.style.display = "table-row";
                }
            }
        )

        this.checkChartByCategoryFilter();
    },
    checkChartByCategoryFilter() {
        if (this.chart == undefined || this.settings.chartData == 0) {
            return;
        }
        if (this.settings.tableSelectCategory == 'Wszystkie') {
            return;
        }
        if (this.settings.tableSelectProduct == 'Wszystkie') {
            return;
        }
    },
    chartOverlayOn() {
        this.settings.elements.chartOverlay.style.display = 'flex';
    },
    chartOverlayOff() {
        this.settings.elements.chartOverlay.style.display = 'none';
    },
    checkChartFilters() {
        if (this.settings.filterChart.tab === null) {
            this.settings.filterChart.tab = 'rate_of_return';
            this.settings.elements.chartTabButtons[0].classList.add('var_active');
        }

        if (this.settings.filterChart.date === null) {
            this.settings.filterChart.date = '12';
            this.settings.elements.chartDateButtons[2].classList.add('var_active');
        }
    },
    chartDateButtonsClickEvent() {
        this.settings.elements.chartDateButtons.forEach(
            el => el.addEventListener(
                'click',
                (e) => {
                    this.getDateButtonData(e);
                    this.styleButtonsBehaviour(e);
                }
            )
        )
    },
    styleButtonsBehaviour(e) {
        const searchClass = e.target.classList[0];
        const lastActiveElement = document.querySelector(`.${searchClass}.var_active`)
        lastActiveElement ? lastActiveElement.classList.remove('var_active') : false;
        e.target.classList.add('var_active');
    },
    getDateButtonData(e) {
        let dataAttribute = (e.target.getAttribute('data-date') === null) ? 'custom' : e.target.getAttribute('data-date');
        if (dataAttribute != this.settings.filterChart.date) {
            this.settings.filterChart.date = dataAttribute;
        }
        this.filterChartByDate()
    },
    filterChartByDate() {
        let $this = this;

        if (this.settings.filterChart.date !== 'custom') {
            this.litepicker.clearSelection();
            this.settings.calendar.initialDate = null;
            this.settings.calendar.endingDate = null;

            if (this.settings.filterChart.tab !== 'exchange_rate') {
                this.getCheckboxData()
            } else {
                this.getDataForCurrencyChart()
            }
        }


    },
    chartTabButtonsClickEvent() {
        this.settings.elements.chartTabButtons.forEach(
            el => el.addEventListener(
                'click',
                (e) => {
                    this.getTabButtonData(e);
                    this.styleButtonsBehaviour(e);
                }
            )
        )
    },
    getTabButtonData(e) {
        let dataAttribute = e.target.getAttribute('data-tab');
        if (dataAttribute !== this.settings.filterChart.tab) {
            this.settings.filterChart.tab = dataAttribute;
            this.filterChartByTab();
        }
    },
    filterChartByTab() {
        //this.litepicker.clearSelection();

        if (this.settings.filterChart.tab === 'exchange_rate') {
            this.litepicker.destroy();
            this.setCalendar();
            this.getDataForCurrencyChart()
        } else {
            this.litepicker.destroy();
            this.setCalendar();
            this.getCheckboxData()
        }
    },
    tableInputsClickEvent() {
        this.settings.elements.checkboxes.forEach(el => el.addEventListener('click', this.getCheckboxData.bind(this)))
    },
    getCheckboxData(el) {
        let checked_inputs = document.querySelectorAll('.funds__table input[type="checkbox"]:checked'),
            $this = this,
            id = [],
            fund_name = [],
            returnRateMonths = this.settings.filterChart.date,
            initialDate = this.settings.calendar.initialDate,
            endingDate = this.settings.calendar.endingDate;


        // Reset chart data

        this.settings.chartData = [];

        if (checked_inputs.length > 0) {
            checked_inputs.forEach(
                (el, i) => {
                    id.push(parseInt(el.dataset.fundid));
                    fund_name.push(el.dataset.fundname);
                }
            )
        } else {
            if ($this.chart !== null) {
                $this.destroyChart(d3.select('#chart'))
            }
        }


        id = id.toString();
        switch (this.settings.filterChart.tab) {
            case 'rate_of_return':
                this.getReturnRateData(id, returnRateMonths, initialDate, endingDate, fund_name)
                break;
            case 'absolute_value':
                this.getFundData(id, returnRateMonths, initialDate, endingDate, fund_name);
                break;
        }

    },
    getDataForCurrencyChart() {
        let returnRateMonths = this.settings.filterChart.date,
            initialDate = this.settings.calendar.initialDate,
            endingDate = this.settings.calendar.endingDate;

        this.settings.chartData = [];


        this.getCurrencyData(returnRateMonths, initialDate, endingDate);

    },
    setCalendar() {
        this.litepicker = new Litepicker(
            {
                element: document.querySelector('#litepicker'),
                parentEl: document.querySelector('.calendar'),
                singleMode: false,
                showTooltip: false,
                dropdowns: {"minYear": 2004, "maxYear": null, "months": true, "years": true},
                maxDate: new Date(),
                lang: "pl-PL",
                setup: (picker) => {
                    picker.on(
                        'selected',
                        (initialDate, endingDate) => {
                            this.settings.calendar.initialDate = d3.time.format('%Y-%m-%d')(new Date(Date.parse(initialDate.dateInstance)))
                            this.settings.calendar.endingDate = d3.time.format('%Y-%m-%d')(new Date(Date.parse(endingDate.dateInstance)))
                            this.settings.calendarContainer.classList.add('var_fill')
                            if (this.settings.filterChart.tab !== 'exchange_rate') {
                                this.getCheckboxData()
                            } else {
                                this.getDataForCurrencyChart()
                            }
                        }
                    )
                    picker.on(
                        'before:show',
                        () => {
                            this.settings.calendarContainer.classList.add('var_active')
                        }
                    )
                    picker.on(
                        'hide',
                        () => {
                            this.settings.calendarContainer.classList.remove('var_active')
                        }
                    )
                    picker.on(
                        'render',
                        (ui) => {
                            if (!this.clearButton) {
                                this.handleCalendarButtons();
                                setTimeout(() => this.styleSelect());
                            } else {
                                this.clearButton = false;
                            }
                            document.querySelector('.calendar .month-item').appendChild(document.querySelector('.reset-button-custom-funds'))

                        }
                    )
                    picker.on(
                        'clear:selection',
                        () => {
                            this.settings.calendarContainer.classList.remove('var_fill')
                        }
                    );
                },
                resetButton: () => {
                    let btn2 = document.createElement('button');
                    btn2.innerText = 'Wyczyść';
                    btn2.className = "reset-button-custom reset-button-custom-funds"
                    btn2.addEventListener(
                        'click',
                        (evt) => {
                            evt.preventDefault();
                            this.settings.currentDate.year = new Date().getFullYear();
                            this.settings.currentDate.month = this.settings.monthArray[new Date().getMonth()];
                            this.clearButton = true;
                            this.litepicker.gotoDate(`${this.settings.currentDate.year}-${this.settings.month[this.settings.currentDate.month]}-01`);
                        }
                    );

                    return btn2;
                }
            }
        )
    },
    styleSelect() {
        const objectThis = this;

        $('.litepicker select').each(
            function () {
                const dateType = this.classList[0] == 'month-item-name' ? 'month' : 'year';

                var $this = $(this), numberOfOptions = $(this).children().length;
                $this.find('option:first-child').attr('value', 'hide');
                $this.addClass('select-hidden');
                $this.wrap(`<div class="select ${dateType}"></div>`);
                $this.after('<div class="select-styled"></div>');

                var label = $this.attr('data-label');
                if (label) {
                    $this.before(`<div class="select-label">${label}</div>`);
                }

                var $styledSelect = $this.next('div.select-styled');

                if (dateType === 'month') {

                    $styledSelect.text(objectThis.settings.currentDate.month);
                } else {
                    $styledSelect.text(objectThis.settings.currentDate.year);
                }

                var $list = $(
                    '<ul />',
                    {
                        'class': `select-options ${dateType}`
                    }
                ).insertAfter($styledSelect);

                for (var i = 0; i < numberOfOptions; i++) {
                    $(
                        '<li />',
                        {
                            html: $this.children().eq(i).html(),
                            rel: $this.children().eq(i).html(),
                            disabled: $this.children().eq(i).attr('disabled')
                        }
                    ).appendTo($list);
                }

                var $listItems = $list.children('li');

                $styledSelect.click(
                    function (e) {
                        e.stopPropagation();
                        $('div.select-styled.active').not(this).each(
                            function () {
                                $(this).removeClass('active').next('ul.select-options').hide();
                            }
                        );
                        $(this).toggleClass('active').next('ul.select-options').toggle();
                    }
                );

                $listItems.each(
                    function () {
                        $(this).wrapInner('<span class="select-options__text"></span>')
                    }
                )

                $listItems.click(
                    function (e) {
                        e.stopPropagation();
                        $styledSelect.removeClass('active');
                        $styledSelect.addClass('selected');
                        $this.val($(this).attr('rel'));
                        $list.hide();

                        objectThis.handleDateChange(this);
                        // $this.trigger( 'change' );
                        // console.log(objectThis.currentDate)
                    }
                );

                $(document).click(
                    function () {
                        $styledSelect.removeClass('active');
                        $list.hide();
                    }
                );

            }
        );
    },
    handleDateChange(clickedElement) {
        const parentElement = clickedElement.parentElement;

        if (parentElement.classList.contains('month')) {
            this.settings.currentDate.month = clickedElement.getAttribute('rel');
            this.litepicker.gotoDate(`${this.settings.currentDate.year}-${this.settings.month[this.settings.currentDate.month]}-01`);
        } else {
            this.settings.currentDate.year = clickedElement.getAttribute('rel');
            this.litepicker.gotoDate(`${this.settings.currentDate.year}-${this.settings.month[this.settings.currentDate.month]}-01`);
        }
    },
    handleCalendarButtons() {
        const prev = document.querySelector('.calendar .button-previous-month');
        const next = document.querySelector('.calendar .button-next-month');

        prev.addEventListener('click', () => this.changeSelectDate(-1));
        next.addEventListener('click', () => this.changeSelectDate(1));
    },
    changeSelectDate(direction) {
        let getCurrentMonthIndex = this.settings.monthArray.indexOf(this.settings.currentDate.month)

        if (getCurrentMonthIndex == 0 && direction == -1) {
            getCurrentMonthIndex = 12;
            this.settings.currentDate.year -= 1;
        } else if (getCurrentMonthIndex == 11 && direction == 1) {
            getCurrentMonthIndex = -1;
            this.settings.currentDate.year += 1;
        }

        if (direction > 0) {
            this.settings.currentDate.month = this.settings.monthArray[getCurrentMonthIndex + 1];
        } else {
            this.settings.currentDate.month = this.settings.monthArray[getCurrentMonthIndex - 1];
        }

    },
    switchContainer() {
        const parent = document.querySelector('.funds__dates');
        const desktop = window.matchMedia('(min-width: 1441px)').matches;

        if (desktop) {
            parent.appendChild(this.settings.calendarContainer);
        } else {
            parent.after(this.settings.calendarContainer)
        }
    },
    sendRequest(url, fund_name) {

        let $this = this,
            data_x_y = [],
            loader = document.querySelectorAll('.funds__loader');
        $.ajax(
            {
                url: url,
                beforeSend: function () {
                    $this.settings.elements.checkboxes.forEach(el => {
                        el.disabled = true
                    })
                    loader.forEach(
                        el => {
                            el.style.display = 'block';
                        }
                    )
                },
                success: function (data) {
                    $this.settings.elements.checkboxes.forEach(el => {
                        el.disabled = false
                    })
                    loader.forEach(
                        el => {
                            el.style.display = 'none';
                        }
                    )
                    data.forEach(
                        function (el, index) {

                            let parent_el = el,
                                parent_index = index;
                            data_x_y[index] = []

                            el.Offsets.double.forEach(
                                function (el, index) {
                                    data_x_y[parent_index].push({
                                        x: Date.parse(el),
                                        y: parseFloat(parent_el.Values.double[index])
                                    })
                                }
                            )
                        }
                    )

                    data_x_y.forEach(
                        function (el, index) {

                            $this.settings.chartData.push(
                                {
                                    values: el,
                                    key: fund_name[index],
                                }
                            )
                        }
                    )

                    $this.drawChart()

                }
            }
        )

    },
    getReturnRateData(fundsId, returnRateMonths, initialDate, endingDate, fund_name) {
        let url = (returnRateMonths !== 'custom') ? `${compensa_general.link}/wp-json/cmp_services/funds?funds_id=${fundsId}&rate_month=${returnRateMonths}&chart=rate_of_return` : `${compensa_general.link}/wp-json/cmp_services/funds?funds_id=${fundsId}&rate_month=-1&chart=rate_of_return&initial_date=${initialDate}&ending_date=${endingDate}`;

        this.sendRequest(url, fund_name)
    },
    getFundData(fundsId, returnRateMonths, initialDate, endingDate, fund_name) {
        let url = (returnRateMonths !== 'custom') ? `${compensa_general.link}/wp-json/cmp_services/funds?funds_id=${fundsId}&rate_month=${returnRateMonths}&chart=absolute_value` : `${compensa_general.link}/wp-json/cmp_services/funds?funds_id=${fundsId}&rate_month=-1&chart=absolute_value&initial_date=${initialDate}&ending_date=${endingDate}`;

        this.sendRequest(url, fund_name)
    },
    getCurrencyData(returnRateMonths, initialDate, endingDate) {
        let fund_name = ['USD-PLN', 'EUR-PLN'],
            url = (returnRateMonths !== 'custom') ? `${compensa_general.link}/wp-json/cmp_services/funds?rate_month=${returnRateMonths}&chart=exchange_rate` : `${compensa_general.link}/wp-json/cmp_services/funds?rate_month=-1&chart=exchange_rate&initial_date=${initialDate}&ending_date=${endingDate}`;

        this.sendRequest(url, fund_name)
    },
    downloadCSV(el) {

        $.ajax(
            {
                method: "POST",
                url: `${compensa_general.link}/wp/wp-admin/admin-ajax.php`,
                data: {
                    'action': 'generate_csv',
                    'fundid': $(el).data('fundid'),
                    'fundName' : $(el).data('fundname'),
                }
            }
        ).done(
            function (data) {
                let csvContent = "data:text/csv;charset=utf-8,",
                    json = JSON.parse(data);
                json.csv.forEach(function(rowArray) {
                    let row = rowArray.join(",");
                    csvContent += row + "\r\n";
                });
                let encodedUri = encodeURI(csvContent),
                    link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", json.fileName);
                document.body.appendChild(link); // Required for FF
                link.click();
            }
        )
    }
}

export default funds;

window.addEventListener('load', () => funds.init())
